import { useContext, useEffect, useState } from "react";
import { delimitationService } from "../services/DelimitationService";
import { Dropdown } from "primereact/dropdown";
import ScreenLoader from "./ScreenLoader";
import { Button } from "primereact/button";
import { changeLang } from "./Language/ChangeLang";
import { AppDB } from "../App";
import { authenticationService } from "../services/AuthenticationService";
import { APP_TYPE } from "../config/Config";
import { CandidateDBContext } from "../pages/CandidateManagement/CandidateDBContext";

export default function ({
	onChange = () => { },
	isNational = false,
	HideApplyLocalDelimitationNational = false,
	politicalDelimitation = {},
	midGridBlock = 3,
	councilGridBlock = 3,
	showFilter = false,
	isDermacationManagement=false,
	showFirstTwo = false,
	showFirstThree = false,
	onFilter = () => { },
	onClearFilter = () => { },
	requiredLevel = 4,
	isReport = false,
	includeVillage = false,
	includeElectorDivision = true,
	includeVotingCentre = true,
	setLocalDelimitation,
	bold = true,
	hideDropdown = false,
	setDelim, showRegistrationCentre = true,
	level1Star = "*",
	level2Star = "*",
	level3Star = "*",
	level4Star = "*",
	level5Star = "*",

}) {
	var raw = {
		districts: [],
		districtID: null,
		districtName: null,
		councils: [],
		councilID: null,
		councilName: null,
		votingDistricts: [],
		votingDistrictID: null,
		votingDistrictName: null,
		votingStations: [],
		votingStationID: null,
		votingStationName: null,
		villages: [],
		villageID: null,
		villageName: null,
		level: null,
		delimitationID: null,

	};
	var [delim, setDelim] = useState(raw);
	var [loading, setLoading] = useState(true);
	var isPoliticalParty = APP_TYPE == "PoliticalParty"
	const { selectedCanditate } = useContext(CandidateDBContext)

	useEffect(() => {
		setLoading(true);
		async function loader() {
			delim = raw;
			var userDelimitations = authenticationService.getUserDelimitation();
			var dist = await delimitationService.getNationalLocalDistrict(isNational);
			// if (isPoliticalParty && dist.length > 0 && userDelimitations.length > 0) {
			// 	const { delimitationLevelID } = dist[0];
			// 	const { districtID, constituencyID } = userDelimitations[0];

			// }
			delim.districts = dist;
			var constituency_name = "";
			delim.districtID = politicalDelimitation?.localDistrictId || politicalDelimitation?.districtId || null;
			delim.councilID = politicalDelimitation?.councilId || politicalDelimitation?.constituencyId || null;
			delim.votingDistrictID = politicalDelimitation?.pollingDivisionId || politicalDelimitation?.localElectoralDevisionId || null;

			delim.votingStationID = politicalDelimitation?.registrationCentreId || null;
			delim.villageID = politicalDelimitation?.villageId || null;
			delim.level = 1;
			delim.delimitationID = delim.districtID;
			if (![null, undefined, ""].includes(delim.districtID)) {
				var consti = await delimitationService.getNationalLocalConstituency(isNational, delim.districtID);
				delim.councils = consti;
				constituency_name = consti.find(e => e.id === delim.councilID)?.name

				if (delim.councilID !== null) {
					delim.level = 2;
					delim.delimitationID = delim.councilID;
				}
			}

			if (![null, undefined, ""].includes(delim.councilID)) {
				var pol = await delimitationService.getNationalLocalVotingDistrict(isNational, delim.councilID);
				delim.votingDistricts = pol;

				if (delim.votingDistrictID !== null) {
					delim.level = 3;
					delim.delimitationID = delim.votingDistrictID;
				}
			}

			if (![null, undefined, ""].includes(delim.votingDistrictID)) {
				var regCenter = await delimitationService.getNationalLocalgetRegistrationCentres(isNational, delim.votingDistrictID);
				delim.votingStations = regCenter;

				if (delim.votingStationID !== null) {
					delim.level = 4;
					delim.delimitationID = delim.votingStationID;
				}
			}

			if (includeVillage && delim.level === 4) {

				if (![null, undefined, ""].includes(delim.votingStationID)) {
					delim.level = 5;
					var villages = await delimitationService.getVillagesByRegistrationCentre(delim.votingStationID);
					delim.villages = villages;
					delim.delimitationID = delim.villageID;
				}
			}
			var clone = JSON.parse(JSON.stringify(delim));
			console.log(clone)
			onChange(delim.delimitationID, delim.level, true, constituency_name);
			setDelim(clone);
			setLoading(false);
		}
		loader();
	}, [isNational]);


	function map_code(_delim = []) {

		if ("isCandidate" in (selectedCanditate ?? {})) {
			var userDelimitations = authenticationService.getUserDelimitation();
			if (isPoliticalParty && _delim.length > 0 && userDelimitations.length > 0) {
				const { delimitationLevelID } = _delim[0];
				const {
					districtId,
					constituencyId,
					pollingDivisionId,
					registrationCentreId } = politicalDelimitation

				//District
				if (delimitationLevelID === 1) {
					_delim = _delim.filter(x => x.id === districtId);
				}

				//Constituency/Council
				if (delimitationLevelID === 2) {
					_delim = delim.councilID === null ? _delim : _delim.filter(x => x.id === constituencyId);
				}

				if (!isNational) {
					if (delimitationLevelID === 3) {
						_delim = delim.votingDistrictID === null ? _delim : _delim.filter(x => x.id === pollingDivisionId);
					}
				}


			}
		}


		var r = _delim?.map(e => {
			var name = e.name;
			var code = e.code;
			e.code = ""
			e.name = ""
			e.name = `${code}-${name}`.replace(/^-/, "");
			return e;
		}) || []
		return r
	}

	return (
		<div key={isReport} className="grid">
			<ScreenLoader visible={loading} />
			<div style={{ "display": hideDropdown ? "none" : "block" }} className={`col-12 md:col-${midGridBlock}`}>
				<b style={{ fontWeight: bold ? "bold" : "normal" }}>
					District <span className='required-input'>{level1Star}</span>
				</b>
				<Dropdown
					disabled={politicalDelimitation?.isByElection}
					value={delim.districtID}
					onChange={(e) => {
						setLoading(true);
						delimitationService.getNationalLocalConstituency(isNational, e.value).then((res) => {
							const selected = delim.districts.find(d => d.id === e.value);
							setDelim({
								...delim,
								districtID: e.value,
								districtName: selected?.name,
								councils: res,
								councilID: null,
								votingDistricts: [],
								votingDistrictID: null,
								votingStations: [],
								votingStationID: null,
								level: 1,
								delimitationID: e.value
							});
							onChange(e.value, 1, true);
							setLoading(false);
						});
					}}
					className="w-full"
					optionValue="id"
					optionLabel="name"
					options={map_code(delim.districts)}
				/>
			</div>
			<div style={{ "display": hideDropdown ? "none" : "block" }} className={`col-12 md:col-${councilGridBlock}`}>
				<b style={{ fontWeight: bold ? "bold" : "normal" }}>
					{isNational ? changeLang.get("national_delimitation.constituency") : changeLang.get("local_delimitation.council")}
					<span className='required-input'>{level2Star}</span>
				</b>
				<Dropdown
					disabled={politicalDelimitation?.isByElection}
					value={delim.councilID}
					onChange={(e) => {
						setLoading(true);
						var constituency_name = delim.councils.find(item => item.id === e.value)?.name
						delimitationService.getNationalLocalVotingDistrict(isNational, e.value).then((res) => {
							setDelim({
								...delim,
								councilID: e.value,
								councilName: constituency_name,
								votingDistricts: res,
								votingDistrictID: null,
								votingStations: [],
								votingStationID: null,
								villages: null,
								villageID: null,
								level: 2,
								delimitationID: e.value
							});
							onChange(e.value, 2, true, constituency_name);
							setLoading(false);
						});
					}}
					className="w-full"
					optionValue="id"
					optionLabel="name"
					options={map_code(delim.councils)}
				/>
			</div>
			{includeElectorDivision && (<>
				<div style={{ "display": hideDropdown ? "none" : "block" }} className={`col-12 md:col-${midGridBlock}`}>
					<b style={{ fontWeight: bold ? "bold" : "normal" }}>
						{isNational ? changeLang.get("national_delimitation.electoralDivision") : changeLang.get("local_delimitation.electoralDivision")}

						{requiredLevel == 4 && <span className='required-input'>{level3Star}</span>}</b>
					<Dropdown
						value={delim.votingDistrictID}
						disabled={politicalDelimitation?.isByElection}
						onChange={(e) => {
							setLoading(true);
							const selected = delim.votingDistricts.find(v => v.id === e.value);
							delimitationService.getNationalLocalgetRegistrationCentres(isNational, e.value).then((res) => {
								setDelim({
									...delim,
									votingStations: res,
									votingDistrictID: e.value,
									votingDistrictName: selected?.name,
									level: 3,
									delimitationID: e.value,
									villages: null,
									villageID: null,

								});
								onChange(e.value, 3, true);
								setLoading(false);
							});
						}}
						className="w-full"
						optionValue="id"
						optionLabel="name"
						options={map_code(delim.votingDistricts)}
					/>
				</div>
			</>)}

			{includeVotingCentre && showRegistrationCentre && (<>
				<div style={{ "display": hideDropdown ? "none" : "block" }} className={`col-12 md:col-${midGridBlock}`}>
					<b style={{ fontWeight: bold ? "bold" : "normal" }}>
						{isNational ? changeLang.get("national_delimitation.votingCentre") : changeLang.get("local_delimitation.pollingStation")}
						{requiredLevel == 4 && <span className='required-input'>{level4Star}</span>}</b>

					<Dropdown
						value={delim.votingStationID}
						onChange={(e) => {
							setLoading(true);
							const selected = delim.votingStations.find(v => v.id === e.value);
							delimitationService.getVillagesByRegistrationCentre(e.value).then((res) => {
								const updatedDelim = {
									...delim,
									villages: res,
									villageID: null,
									votingStationID: e.value,
									votingStationName: selected?.name,  
									level: 4,
									delimitationID: e.value
								};
								setDelim(updatedDelim);  
								if(isDermacationManagement){
									setLocalDelimitation(updatedDelim);
								}
								onChange(updatedDelim.delimitationID, updatedDelim.level, true);
								setLoading(false);
							});
						}}
						className="w-full"
						optionValue="id"
						optionLabel="name"
						options={map_code(delim.votingStations)}
					/>


				</div>
			</>)}
			{includeVillage && (<div style={{ "display": hideDropdown ? "none" : "block" }} className={`col-12 md:col-${midGridBlock}`}>
				<b style={{ fontWeight: bold ? "bold" : "normal" }}>
					{isNational ? changeLang.get("national_delimitation.village") : changeLang.get("local_delimitation.village")}
					{<span className='required-input'>{level5Star}</span>}</b>
				<Dropdown
					value={delim.villageID}
					onChange={(e) => {
						setDelim({ ...delim, villageID: e.value, level: 5, delimitationID: e.value });
						try {
							onChange(e.value, 5, true);
						} catch (error) { }
					}}
					className="w-full"
					optionValue="id"
					optionLabel="name"
					options={map_code(delim.villages)}
				/>
			</div>)}
			<div className="col-12 mb-4">
				<>
					{showFilter && (
						<>
							{!HideApplyLocalDelimitationNational && (
								<Button
									disabled={[null, undefined, ""].includes(politicalDelimitation)}
									label="Apply"
									onClick={(e) => {
										onFilter({ delimitationID: delim.delimitationID, delimitationLevelID: delim.level });
									}}
									className="mt-4 mr-2 p-button-primary"
									size="small"
								/>
							)}
							<Button
								label="Clear"
								disabled={[null, undefined, ""].includes(politicalDelimitation)}
								onClick={() => {
									try {
										onClearFilter()
									} catch (error) {

									}
									try {

										setDelim({
											...delim,
											districtID: null,
											councils: [],
											councilID: null,
											votingDistricts: [],
											votingDistrictID: null,
											votingStations: [],
											votingStationID: null,
											level: null,
											delimitationID: null
										});
									} catch (error) {

									}
								}}
								className="mt-4 p-button-primary"
								size="small"
							/>
						</>
					)}


				</>
			</div>

		</div>
	);
}
